import { render, staticRenderFns } from "./restaurant_sms.vue?vue&type=template&id=1f1508b8&scoped=true&"
import script from "./restaurant_sms.vue?vue&type=script&lang=js&"
export * from "./restaurant_sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1508b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1508b8')) {
      api.createRecord('1f1508b8', component.options)
    } else {
      api.reload('1f1508b8', component.options)
    }
    module.hot.accept("./restaurant_sms.vue?vue&type=template&id=1f1508b8&scoped=true&", function () {
      api.rerender('1f1508b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/restaurant_sms.vue"
export default component.exports